export default __webpack_public_path__ + "static/media/Mayura_1.75ee5124.png";